import React, { useState, useEffect, useContext, useTransition } from "react";
import { ConfigContext } from "../../Context/ConfigContext";
import axios from "axios";
import { NavLink } from "react-router-dom";
import { OverlayLoader, Spinner } from "../../Components/Shimmers";
import AccountSiderBar from "./AccountSideBar";
import { useTranslation } from 'react-i18next';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import dayjs from "dayjs";
import { axiosGet } from "../../Apis/axiosMethods";

const RequestedRedeemPoints = () => {
  const { t } = useTranslation();
  const { token, apiB2BURL } = useContext(ConfigContext);
  const [orders, setOrders] = useState([]);
  const [ordersLoading, setOrdersLoading] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    GetOrders();
  }, []);

  const GetOrders = async () => {
    try {
      setOrdersLoading(true);

      const business_id = localStorage.getItem("business_id");
      const business_user_id = localStorage.getItem("business_user_id");

      const response = await axiosGet(`/Users/GetRedeemRequest`,
        {
          business_id,
          business_user_id
        }
      );

      if (response.data.success) {
        setOrders(response.data.data);
      } else {
        console.log("Error While Fetching Customer Orders", response.data.message);
      }

    } catch (error) {
      console.log("Oops Something Went Wrong", error);
    } finally {
      setOrdersLoading(false);
    }
  };

  const dir = localStorage.getItem('dir');

  return (
    <>
      {
        ordersLoading ?
          <div style={{ height: "70vh" }}>
            <OverlayLoader />
          </div>
          :
          <main style={{ marginTop: '-10px' }}>
            <div className="page-header">
              <div className="container d-flex flex-column align-items-center">
                <nav aria-label="breadcrumb" className="breadcrumb-nav">
                  <div className="container">
                    <ol className="breadcrumb" dir={dir}>
                      <li className="breadcrumb-item">
                        <NavLink to={'/'}>{t("home")}</NavLink>
                      </li>
                      <li className="breadcrumb-item">
                        <NavLink to={`/MyAccount`}>{t("my_account")}</NavLink>
                      </li>
                      <li className="breadcrumb-item active" aria-current="page">
                        Requested Redeem Points
                      </li>
                    </ol>
                  </div>
                </nav>
                <h1>{t("Requested Redeem Points")}</h1>
              </div>
            </div>
            <div className="container account-container custom-account-container">
              <div className="row">
                <AccountSiderBar />
                <div className="col-lg-12 order-lg-last order-1 tab-content">
                  <div className="tab-pane fade show active" id="address" role="tabpanel">
                    <div className="order-content">
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '1rem'
                      }}>
                        <h3 className={`account-sub-title d-none d-md-block mb-0 ${dir === 'rtl' ? 'text-right' : ''}`} dir={dir}>
                          <i className="sicon-social-dropbox align-middle mr-3" />
                          {t("Requested Redeem Points")}
                        </h3>

                      </div>

                      <div className="order-table-container text-center">
                        <table className="table table-order text-left">
                          <thead>
                            <tr>
                              <th width="10%" className="order-id">Request ID</th>
                              <th width="20%" className="order-date">Request Date</th>
                              <th width="10%" className="order-status">Picture</th>
                              <th width="40%" className="order-status">Offer</th>
                              <th width="40%" className="order-status">Remark</th>
                              <th width="10%" className="order-price">Points</th>
                              <th width="10%" className="order-action">Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {orders.length > 0 ? (
                              orders.map((order) => (
                                <tr key={order.secret_order_id}>
                                  <td className="redeem-id">{order?.business_redeem_point_id}</td>
                                  <td className="order-date">{dayjs(order?.redeem_point_requested_date).format("DD-MM-YYYY")}</td>
                                  <td className="order-date">
                                    <img
                                      src={order.business_redeem_offer_image_url}
                                      style={{ height: '50px', objectFit: 'cover' }}
                                      alt={order?.business_redeem_offer_title}
                                    />
                                  </td>
                                  <td className="order-status">{order?.business_redeem_offer_title}</td>
                                  <td className="order-status">{order?.business_redeem_point_remark}</td>
                                  <td className="order-price">{order?.business_redeem_points}</td>
                                  <td>
                                    <span
                                      className={`badge 
                                      ${order?.business_redeem_status === 0 ? "bg-warning" : ""}
                                      ${order?.business_redeem_status === 1 ? "bg-primary" : ""}
                                      ${order?.business_redeem_status === 2 ? "bg-info" : ""}
                                      ${order?.business_redeem_status === 3 ? "bg-success" : ""}
                                      ${order?.business_redeem_status === 4 ? "bg-danger" : ""}
                                      ${order?.business_redeem_status === 5 ? "bg-dark" : ""}
                                      text-white
                                      `}
                                    >
                                      {order?.business_redeem_status_label}
                                    </span>
                                  </td>


                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td className="text-center p-0" colSpan={5}>
                                  <p className="mb-5 mt-5">No Redeem Requests Found</p>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                        <hr className="mt-0 mb-3 pb-2" />
                        <NavLink to={`/MyAccount/RedeemPoints`} className="btn btn-primary">
                          Check Redeem Offers
                        </NavLink>
                      </div>
                    </div>
                    {/* <MembershipPolicy /> */}
                  </div>
                </div>
              </div>
            </div>
          </main>
      }
    </>
  );

};

export default RequestedRedeemPoints;
